import React from 'react';
import { GivelifyLabel } from '@givelify/ui';
import GiveNowIllustration from '../../../../assets/online-giving/givenow-illustration.svg';
import { useTranslations } from '../../../../utils/translations';
import {
    Content,
    Illustration,
    MainBox,
    SectionTitle,
    TextDivider,
} from './style';

export const CustomModalContent: React.FCC = () => {
    const { customModal: cm } = useTranslations('onlineGiving.givelifyButton', {
        customModal: [
            'title',
            'color',
            'colorDesc',
            'placement',
            'placementDesc',
        ],
    });
    return (
        <Content data-testid="custom-modal-content">
            <GivelifyLabel text={cm.title} variant="heading2S" />
            <Illustration alt="Give now" src={GiveNowIllustration} />
            <MainBox>
                <SectionTitle text={cm.color} variant="body1B" />
                <GivelifyLabel text={cm.colorDesc} variant="body1" />
                <TextDivider />
                <SectionTitle text={cm.placement} variant="body1B" />
                <GivelifyLabel text={cm.placementDesc} variant="body1" />
            </MainBox>
        </Content>
    );
};
